import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=36d33e6f&scoped=true&"
import script from "./Drafts.vue?vue&type=script&lang=js&"
export * from "./Drafts.vue?vue&type=script&lang=js&"
import style0 from "./Drafts.vue?vue&type=style&index=0&id=36d33e6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d33e6f",
  null
  
)

export default component.exports